/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { WelcomeWidgetsMenusIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Info Box' ),
	description: __( 'Gutenify Info Box' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Info Box' ),
	],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		// customClassName: true,
		// color: {
		// 	gradients: true,
		// 	link: true,
		// },
	},
	providesContext: {
		'my-plugin/recordId': 'iconAlign',
	},
};

export { name, category, settings };

